import { render, staticRenderFns } from "./company.vue?vue&type=template&id=d3c5d7f0&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=d3c5d7f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c5d7f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3c5d7f0')) {
      api.createRecord('d3c5d7f0', component.options)
    } else {
      api.reload('d3c5d7f0', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=d3c5d7f0&scoped=true", function () {
      api.rerender('d3c5d7f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/user/organization/company.vue"
export default component.exports